






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FeatureBlockDto, FeatureBlockGroupDto, LinkDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';

@Component({
  components: {CmsLink},
})
export default class FeatureBlockGroup extends Vue {
  @Prop({required: true})
  public readonly model!: FeatureBlockGroupDto;

  get featureBlocks(): FeatureBlockDto[] {
    return this.model.elements;
  }

  public hasTitle(block: FeatureBlockDto): boolean {
    return !!block.title;
  }

  public hasCaption(link: LinkDto): boolean {
    return !!link.caption;
  }
}
